module.exports = __webpack_public_path__ + "img/5-consumers-and-stylists-tape.png";